import 'zone.js';
import { bootstrap } from '../planner/bootstrap';

bootstrap();
